import { useLocalObservable } from 'mobx-react-lite';

import { PopupStore } from '@gem/popups/dist';

import Tasks from 'APP/Tasks';
import { TrustedDeviceRequestPopup } from 'APP/main/PopupManager/Popups/TrustedDeviceRequestPopup/TrustedDeviceRequestPopup';
import { IUserDevicesItem } from 'APP/model/userSettings/userSettingsModel.types';
import Entities from 'STORE';

interface ISignInDeviceRequestsToastPresenter {
  childPopup: PopupStore | null;
  isPopupShown: boolean;
  deviceRequest: IUserDevicesItem | null;
  showRequest(): void;
}

export const useSignInDeviceRequestsToastPresenter = (): ISignInDeviceRequestsToastPresenter => {
  const presenter = useLocalObservable<ISignInDeviceRequestsToastPresenter>(() => ({
    childPopup: null,

    get isPopupShown(): boolean {
      return !!presenter.childPopup;
    },

    get deviceRequest(): IUserDevicesItem | null {
      return Entities.sessionsStore.sessionsForApprove[0];
    },

    showRequest(): void {
      presenter.childPopup = Tasks.app.openPopup(TrustedDeviceRequestPopup, {
        onClose() {
          presenter.childPopup = null;
        },
        params: {
          deviceId: presenter.deviceRequest!.device.deviceId!,
        },
      });
    },
  }));

  return presenter;
};
